export default {
  state: {
    user: null
  },
  mutations: {
    setUser(state, payload) {
      state.user = payload;
    }
  },
  actions: {
    autoSignIn({ commit, rootState, dispatch }, payload) {
      return new Promise((resolve, reject) => {
        let userDetails = {
          admin: false,
          staff: false,
          organisation: false,
          student: true,
          uid: payload.uid,
          displayName: payload.displayName,
          email: payload.email
        };
        // Check user permissions
        rootState.db
          .doc("roles/admin/users/" + payload.uid)
          .get()
          .then(function(doc) {
            if (doc.exists) {
              //console.log("Is admin!");
              userDetails.admin = true;
            } else {
              //console.log("Not admin!");
            }
            return rootState.db.doc("roles/staff/users/" + payload.uid).get();
          })
          .then(function(doc) {
            if (doc.exists) {
              //console.log("Is staff!");
              userDetails.staff = true;
            } else {
              //console.log("Not staff!");
            }
            return rootState.db
              .doc("roles/academic/users/" + payload.uid)
              .get();
          })
          .then(function(doc) {
            if (doc.exists) {
              //console.log("Is academic!");
              userDetails.academic = true;
            } else {
              //console.log("Not academic!");
            }
            return rootState.db
              .doc("roles/organisation/users/" + payload.uid)
              .get();
          })
          .then(function(doc) {
            if (doc.exists) {
              //console.log("Is organisation!");
              userDetails.organisation = true;
              userDetails.student = false;
            } else {
              //console.log("Not organisation!");
            }
            commit("setUser", userDetails);
            resolve("logged in successfully");
          })
          .catch(function(error) {
            console.log("Error getting document:", error);
            reject(error);
          });
      });
    },
    logout({ commit, rootState }) {
      rootState.auth().signOut();
      commit("setUser", null);
    }
  },
  getters: {
    user: state => {
      return state.user;
    }
  }
};
